export default {"src":"/_next/static/media/locator.ad4705de.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};